import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { VActionIcon } from '@vision/ui/components/VActionIcon/VActionIcon';
import { forwardRef } from 'react';
import type { RowActionButtonOptions } from './types';

export const RemoveRowButton = forwardRef<HTMLButtonElement, RowActionButtonOptions>(({ label, ...props }, ref) => (
  <VActionIcon
    color="gray.5"
    size="input-sm"
    variant="light"
    {...props}
    aria-label={label}
    ref={ref}
    tooltipLabel={label}
    type="button"
  >
    <FontAwesomeIcon icon={faTrashCan} aria-hidden="true" />
  </VActionIcon>
));
